import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useGeoPrice } from '../hooks/useGeoPrice';
export function PricingSection() {
  const {
    current,
    compareAt,
    savings,
    currency,
    loading,
    convertPrice,
    checkoutUrl
  } = useGeoPrice();
  const valueStackItems = [{
    name: 'Generador de Volumen Industrial',
    usd: 97
  }, {
    name: 'Angle-Splitter Automático',
    usd: 47
  }, {
    name: 'Base de Conocimiento',
    usd: 27
  }, {
    name: 'Exportación a Meta Ads',
    usd: 17
  }, {
    name: 'BONUS: Plantillas de Copy',
    usd: 27
  }, {
    name: 'BONUS: Guía de Ángulos',
    usd: 17
  }, {
    name: 'BONUS: Comunidad Privada',
    usd: 12
  }, {
    name: 'BONUS: Updates de por Vida',
    usd: 0
  }];
  return <section id="pricing" className="py-24 bg-gradient-to-b from-[#150B24] to-[#020202] relative" data-id="element-221">
      <div className="container mx-auto px-4" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-extrabold mb-6" data-id="element-224">
            Elegí tu plan y empezá a escalar hoy
          </h2>
          <p className="text-purple-200/80 text-xl" data-id="element-225">
            Acceso por 30 días. Cancelá o pausá cuando quieras.
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-226">
          {/* Value Stack */}
          <div className="bg-[#0F0A16] border border-white/10 rounded-t-[24px] md:rounded-t-[32px] p-6 md:p-8 pb-16 relative z-0 translate-y-8" data-id="element-227">
            <h3 className="text-center text-gray-500 font-bold mb-8 uppercase tracking-widest text-xs" data-id="element-228">
              Todo lo que incluye:
            </h3>
            <ul className="space-y-4 text-sm md:text-base text-gray-300 mb-8" data-id="element-229">
              {valueStackItems.map((item, i) => <li key={i} className="flex justify-between items-center border-b border-white/5 pb-3 last:border-0" data-id="element-230">
                  <span className="flex items-center gap-3" data-id="element-231">
                    <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-232" />
                    {item.name}
                  </span>
                  <span className="text-gray-500 font-mono" data-id="element-233">
                    {item.usd === 0 ? 'Incalculable' : `$${convertPrice(item.usd)}`}
                  </span>
                </li>)}
            </ul>
            <div className="text-center pt-6 border-t border-white/10" data-id="element-234">
              <p className="text-gray-500 text-sm mb-1" data-id="element-235">Valor Total Real</p>
              <p className="text-2xl font-bold text-gray-400 line-through decoration-red-500" data-id="element-236">
                {loading ? '$228 USD' : `$${compareAt} ${currency}`}
              </p>
            </div>
          </div>

          {/* Main Card */}
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="bg-[#050505] border-2 border-purple-500 rounded-[28px] md:rounded-[40px] p-6 md:p-12 relative z-10 shadow-[0_0_80px_rgba(139,92,246,0.25)] text-center" data-id="element-237">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-8 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-238">
              Oferta de Lanzamiento
            </div>

            <div className="mb-10 mt-6" data-id="element-239">
              <div className="inline-block bg-green-500/10 text-green-400 border border-green-500/20 px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-240">
                {loading ? 'Ahorrás $171 USD' : `Ahorrás $${savings} ${currency}`}
              </div>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-241">
                <span className="text-6xl md:text-8xl font-extrabold text-white tracking-tighter font-sora" data-id="element-242">
                  {loading ? '$57' : `$${current}`}
                </span>
                <span className="text-2xl text-gray-500 font-medium self-end mb-4" data-id="element-243">
                  {loading ? 'USD' : currency}
                </span>
              </div>
              <p className="text-gray-400 font-medium text-lg" data-id="element-244">
                Acceso por 30 días · Sin permanencia
              </p>
            </div>

            <div className="text-left max-w-xs mx-auto space-y-3 mb-10 text-base text-gray-300" data-id="element-245">
              <p className="flex items-center gap-3" data-id="element-246">
                <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-247" /> Acceso
                inmediato a la plataforma
              </p>
              <p className="flex items-center gap-3" data-id="element-248">
                <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-249" /> Todos los
                bonus incluidos
              </p>
              <p className="flex items-center gap-3" data-id="element-250">
                <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-251" /> Cancelá o
                pausá cuando quieras
              </p>
              <p className="flex items-center gap-3" data-id="element-252">
                <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-253" /> Probá un mes
                sin compromiso
              </p>
            </div>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full bg-white text-black hover:bg-gray-200 font-bold text-xl py-6 rounded-2xl shadow-lg transform hover:-translate-y-1 transition-all duration-300 mb-8 text-center" data-id="element-254">
              ACCEDER A LA APP →
            </a>

            <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-xs text-gray-500 uppercase font-bold tracking-wider" data-id="element-255">
              <span className="flex items-center gap-1" data-id="element-256">🔒 Pago seguro</span>
              <span className="hidden md:inline text-white/20" data-id="element-257">•</span>
              <span className="flex items-center gap-1" data-id="element-258">
                ⚡ Acceso inmediato
              </span>
              <span className="hidden md:inline text-white/20" data-id="element-259">•</span>
              <span className="flex items-center gap-1" data-id="element-260">
                🔄 Garantía 7 días
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}